import type { ComponentProps } from "react";

import { translate } from "app/filters/i18nFilter";
import type { SearchResultsTableWithTrialHook } from "app/pages/sales-intelligence/common-components/search-results-table";

export const TECHNOLOGIES_TRIAL_HOOK_PROPS: ComponentProps<typeof SearchResultsTableWithTrialHook>["trialHookProps"] = {
    trackingEventName: "technologies hook",
    get title() {
        return translate("si.company-analysis.technologies.trial-overlay-hook.title");
    },
    get subTitle() {
        return translate("si.company-analysis.technologies.trial-overlay-hook.subtitle");
    },
};
